const middleEastAfricaRecipes = [
  // ─── LEBANESE (4) ───────────────────────────────────────────────────

  {
    title: 'Chicken Shawarma',
    description:
      'Warmly spiced chicken thighs marinated in a yogurt-cumin blend, roasted until caramelized, and served with garlic sauce and pickled turnips. A street-food icon that delivers layers of flavor in every bite.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/chicken-shawarma.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/chicken-shawarma-prep.jpg', caption: 'Marinated chicken on the cutting board', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 30,
    cookTime: 25,
    totalTime: 55,
    difficulty: 'medium',
    spiceLevel: 2,

    cuisine: 'Lebanese',
    region: 'Middle East',
    country: 'Lebanon',

    categories: ['Dinner'],
    tags: ['high-protein', 'high-iron', 'dairy-free', 'meal-prep', 'weeknight-dinner', 'family-friendly'],

    ageGroups: ['kid', 'teen', 'adult'],

    nutrition: {
      calories: 480,
      protein: 38,
      carbs: 12,
      fat: 32,
      fiber: 1,
      sugar: 3,
      sodium: 720,
      iron: 3.0,
    },

    ingredients: [
      { qty: 2, unit: 'lb', item: 'boneless skinless chicken thighs', group: 'Chicken' },
      { qty: 0.5, unit: 'cup', item: 'plain yogurt', group: 'Marinade' },
      { qty: 3, unit: 'tbsp', item: 'olive oil', group: 'Marinade' },
      { qty: 4, unit: '', item: 'garlic cloves, minced', group: 'Marinade' },
      { qty: 2, unit: 'tsp', item: 'ground cumin', group: 'Marinade' },
      { qty: 1, unit: 'tsp', item: 'ground turmeric', group: 'Marinade' },
      { qty: 1, unit: 'tsp', item: 'smoked paprika', group: 'Marinade' },
      { qty: 0.5, unit: 'tsp', item: 'ground cinnamon', group: 'Marinade' },
      { qty: 0.5, unit: 'tsp', item: 'ground cardamom', group: 'Marinade' },
      { qty: 0.25, unit: 'tsp', item: 'cayenne pepper', group: 'Marinade' },
      { qty: 1, unit: 'tbsp', item: 'lemon juice', group: 'Marinade' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Marinade' },
      { qty: 0.5, unit: 'tsp', item: 'black pepper', group: 'Marinade' },
      { qty: 4, unit: '', item: 'pita breads', group: 'Serving' },
      { qty: 1, unit: 'cup', item: 'pickled turnips', group: 'Serving' },
      { qty: 0.5, unit: 'cup', item: 'garlic sauce (toum)', group: 'Serving' },
    ],
    steps: [
      { order: 1, instruction: 'Whisk together yogurt, olive oil, garlic, cumin, turmeric, paprika, cinnamon, cardamom, cayenne, lemon juice, salt, and pepper in a large bowl. Add chicken thighs and toss until well coated. Cover and refrigerate for at least 2 hours or overnight.', timerMinutes: null },
      { order: 2, instruction: 'Preheat the oven to 425 F. Line a sheet pan with foil and set a wire rack on top. Arrange the marinated chicken in a single layer on the rack.', timerMinutes: null },
      { order: 3, instruction: 'Roast the chicken for 20-25 minutes, until deeply golden and the internal temperature reaches 175 F. For extra char, broil for 2-3 minutes at the end.', timerMinutes: 25 },
      { order: 4, instruction: 'Let the chicken rest for 5 minutes, then slice thinly against the grain.', timerMinutes: 5 },
      { order: 5, instruction: 'Warm the pita breads in the oven or on a dry skillet for about 1 minute per side.', timerMinutes: 2 },
      { order: 6, instruction: 'Assemble the shawarma by layering sliced chicken, pickled turnips, and a generous drizzle of garlic sauce inside each pita. Serve immediately.', timerMinutes: null },
    ],
    notes: 'For the most authentic flavor, marinate overnight. You can substitute chicken breasts, but thighs stay juicier. Toum (Lebanese garlic sauce) can be found at Middle Eastern grocers or made by emulsifying garlic, lemon juice, salt, and oil in a food processor.',

    communityRating: 4.8,
    communityRatingCount: 420,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-15').toISOString(),
  },

  {
    title: 'Falafel',
    description:
      'Crispy, herb-packed chickpea fritters with a golden crust and fluffy emerald interior. Made from soaked dried chickpeas for the perfect texture that canned beans can never achieve.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/falafel.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/falafel-prep.jpg', caption: 'Formed falafel patties ready for frying', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 20,
    cookTime: 15,
    totalTime: 35,
    difficulty: 'medium',
    spiceLevel: 1,

    cuisine: 'Lebanese',
    region: 'Middle East',
    country: 'Lebanon',

    categories: ['Dinner', 'Appetizers', 'Family Meals'],
    tags: ['vegan', 'high-fiber', 'high-protein', 'high-iron', 'dairy-free', 'egg-free', 'freezer-friendly', 'batch-cooking', 'budget-friendly'],

    ageGroups: ['kid', 'teen', 'adult'],
    audience: 'family',

    nutrition: {
      calories: 340,
      protein: 14,
      carbs: 38,
      fat: 16,
      fiber: 9,
      sugar: 4,
      sodium: 520,
      iron: 4.5,
    },

    ingredients: [
      { qty: 1, unit: 'lb', item: 'dried chickpeas, soaked overnight and drained', group: 'Falafel' },
      { qty: 1, unit: 'cup', item: 'fresh parsley, packed', group: 'Falafel' },
      { qty: 0.5, unit: 'cup', item: 'fresh cilantro, packed', group: 'Falafel' },
      { qty: 1, unit: '', item: 'small yellow onion, quartered', group: 'Falafel' },
      { qty: 5, unit: '', item: 'garlic cloves', group: 'Falafel' },
      { qty: 1.5, unit: 'tsp', item: 'ground cumin', group: 'Falafel' },
      { qty: 1, unit: 'tsp', item: 'ground coriander', group: 'Falafel' },
      { qty: 0.25, unit: 'tsp', item: 'cayenne pepper', group: 'Falafel' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Falafel' },
      { qty: 0.5, unit: 'tsp', item: 'black pepper', group: 'Falafel' },
      { qty: 1, unit: 'tsp', item: 'baking powder', group: 'Falafel' },
      { qty: 3, unit: 'tbsp', item: 'all-purpose flour', group: 'Falafel' },
      { qty: 3, unit: 'cups', item: 'vegetable oil, for frying', group: 'Frying' },
      { qty: 0.5, unit: 'cup', item: 'tahini sauce', group: 'Serving' },
      { qty: 4, unit: '', item: 'pita breads', group: 'Serving' },
    ],
    steps: [
      { order: 1, instruction: 'Add soaked, drained chickpeas to a food processor along with parsley, cilantro, onion, and garlic. Pulse about 40 times until the mixture resembles coarse sand -- do not puree into a paste.', timerMinutes: null },
      { order: 2, instruction: 'Transfer to a bowl and stir in cumin, coriander, cayenne, salt, pepper, baking powder, and flour. Mix until evenly combined. Cover and refrigerate for 30 minutes to firm up.', timerMinutes: 30 },
      { order: 3, instruction: 'Heat vegetable oil in a deep pot or Dutch oven to 350 F. Line a plate with paper towels.', timerMinutes: null },
      { order: 4, instruction: 'Using a falafel scoop or your hands, form the mixture into 1.5-inch balls or patties. Gently flatten slightly.', timerMinutes: null },
      { order: 5, instruction: 'Fry the falafel in batches of 5-6 for about 3-4 minutes, turning once, until deeply golden brown on all sides. Transfer to the paper-towel-lined plate.', timerMinutes: 4 },
      { order: 6, instruction: 'Serve falafel in warmed pita with tahini sauce, diced tomatoes, and pickles.', timerMinutes: null },
    ],
    notes: 'Never use canned chickpeas -- they are too wet and the falafel will fall apart. You must soak dried chickpeas for 12-24 hours. Formed, uncooked falafel freeze beautifully; fry straight from frozen, adding 1-2 extra minutes of cook time.',

    communityRating: 4.7,
    communityRatingCount: 380,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-15').toISOString(),
  },

  {
    title: 'Tabbouleh',
    description:
      'A vibrant Lebanese parsley salad with bulgur wheat, juicy tomatoes, and a bright lemon-olive oil dressing. The herb-to-grain ratio is the secret -- parsley is the star, not a garnish.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/tabbouleh.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/tabbouleh-prep.jpg', caption: 'Chopped herbs and vegetables', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 25,
    cookTime: 0,
    totalTime: 25,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'Lebanese',
    region: 'Middle East',
    country: 'Lebanon',

    categories: ['Salads', 'Sides'],
    tags: ['vegan', 'high-fiber', 'high-iron', 'dairy-free', 'egg-free', 'nut-free', 'no-cook', 'under-30-min', 'budget-friendly', 'make-ahead'],

    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 180,
      protein: 5,
      carbs: 22,
      fat: 10,
      fiber: 5,
      sugar: 3,
      sodium: 310,
      iron: 3.8,
    },

    ingredients: [
      { qty: 0.33, unit: 'cup', item: 'fine bulgur wheat', group: 'Salad' },
      { qty: 3, unit: 'cups', item: 'fresh flat-leaf parsley, finely chopped (about 3 large bunches)', group: 'Salad' },
      { qty: 0.5, unit: 'cup', item: 'fresh mint, finely chopped', group: 'Salad' },
      { qty: 3, unit: '', item: 'ripe Roma tomatoes, finely diced', group: 'Salad' },
      { qty: 3, unit: '', item: 'green onions, thinly sliced', group: 'Salad' },
      { qty: 0.25, unit: 'cup', item: 'extra-virgin olive oil', group: 'Dressing' },
      { qty: 0.25, unit: 'cup', item: 'fresh lemon juice (about 2 lemons)', group: 'Dressing' },
      { qty: 0.75, unit: 'tsp', item: 'salt', group: 'Dressing' },
      { qty: 0.25, unit: 'tsp', item: 'black pepper', group: 'Dressing' },
      { qty: 0.25, unit: 'tsp', item: 'ground allspice', group: 'Dressing' },
    ],
    steps: [
      { order: 1, instruction: 'Place bulgur in a small bowl and cover with 1/3 cup boiling water. Cover and let sit for 10 minutes until the water is absorbed and the bulgur is tender. Fluff with a fork and let cool completely.', timerMinutes: 10 },
      { order: 2, instruction: 'While the bulgur soaks, finely chop the parsley and mint. The key is to chop by hand with a sharp knife -- a food processor will bruise the herbs.', timerMinutes: null },
      { order: 3, instruction: 'Dice the tomatoes into small, uniform pieces. Thinly slice the green onions.', timerMinutes: null },
      { order: 4, instruction: 'In a large bowl, combine the cooled bulgur, parsley, mint, tomatoes, and green onions.', timerMinutes: null },
      { order: 5, instruction: 'Whisk together olive oil, lemon juice, salt, pepper, and allspice. Pour over the salad and toss gently to combine.', timerMinutes: null },
      { order: 6, instruction: 'Taste and adjust lemon juice and salt as needed. Serve immediately or refrigerate for up to 4 hours to let the flavors meld.', timerMinutes: null },
    ],
    notes: 'Authentic tabbouleh is mostly parsley with just a small amount of bulgur. Drain the tomatoes briefly on a paper towel if they are very juicy to avoid a soggy salad. Leftovers keep for one day but are best eaten fresh.',

    communityRating: 4.3,
    communityRatingCount: 210,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-15').toISOString(),
  },

  {
    title: 'Fattoush',
    description:
      'A crunchy Lebanese bread salad with crisp pita chips, fresh vegetables, and a tangy sumac-lemon dressing. The interplay of crunchy toasted bread, juicy tomatoes, and tart sumac makes this irresistible.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/fattoush.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/fattoush-prep.jpg', caption: 'Toasted pita chips on a baking sheet', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 15,
    cookTime: 10,
    totalTime: 25,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'Lebanese',
    region: 'Middle East',
    country: 'Lebanon',

    categories: ['Salads', 'Sides'],
    tags: ['vegan', 'high-fiber', 'dairy-free', 'egg-free', 'nut-free', 'under-30-min', 'budget-friendly', 'weeknight-dinner'],

    ageGroups: ['kid', 'teen', 'adult'],

    nutrition: {
      calories: 220,
      protein: 5,
      carbs: 28,
      fat: 11,
      fiber: 4,
      sugar: 5,
      sodium: 440,
      iron: 2.1,
    },

    ingredients: [
      { qty: 2, unit: '', item: 'pita breads, split open', group: 'Pita Chips' },
      { qty: 2, unit: 'tbsp', item: 'olive oil', group: 'Pita Chips' },
      { qty: 0.25, unit: 'tsp', item: 'salt', group: 'Pita Chips' },
      { qty: 1, unit: '', item: 'head romaine lettuce, chopped', group: 'Salad' },
      { qty: 2, unit: '', item: 'Roma tomatoes, diced', group: 'Salad' },
      { qty: 1, unit: '', item: 'English cucumber, diced', group: 'Salad' },
      { qty: 5, unit: '', item: 'radishes, thinly sliced', group: 'Salad' },
      { qty: 3, unit: '', item: 'green onions, sliced', group: 'Salad' },
      { qty: 0.5, unit: 'cup', item: 'fresh mint leaves, torn', group: 'Salad' },
      { qty: 0.5, unit: 'cup', item: 'fresh parsley, chopped', group: 'Salad' },
      { qty: 0.25, unit: 'cup', item: 'extra-virgin olive oil', group: 'Dressing' },
      { qty: 3, unit: 'tbsp', item: 'lemon juice', group: 'Dressing' },
      { qty: 1, unit: 'tbsp', item: 'pomegranate molasses', group: 'Dressing' },
      { qty: 2, unit: 'tsp', item: 'ground sumac', group: 'Dressing' },
      { qty: 1, unit: '', item: 'garlic clove, minced', group: 'Dressing' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Dressing' },
    ],
    steps: [
      { order: 1, instruction: 'Preheat the oven to 375 F. Tear or cut the pita into roughly 1-inch pieces and spread on a baking sheet. Drizzle with olive oil, sprinkle with salt, and toss to coat.', timerMinutes: null },
      { order: 2, instruction: 'Bake the pita chips for 8-10 minutes, tossing halfway through, until golden and crispy. Set aside to cool.', timerMinutes: 10 },
      { order: 3, instruction: 'While the pita bakes, chop the romaine, dice the tomatoes and cucumber, slice the radishes and green onions, and tear the mint leaves. Combine all vegetables and herbs in a large salad bowl.', timerMinutes: null },
      { order: 4, instruction: 'Whisk together olive oil, lemon juice, pomegranate molasses, sumac, garlic, and salt in a small bowl until emulsified.', timerMinutes: null },
      { order: 5, instruction: 'Pour the dressing over the salad and toss to coat evenly. Add the cooled pita chips and toss once more.', timerMinutes: null },
      { order: 6, instruction: 'Serve immediately so the pita chips stay crunchy. Sprinkle extra sumac on top for garnish.', timerMinutes: null },
    ],
    notes: 'The pita chips must be added just before serving or they will get soggy. Sumac is essential -- it gives fattoush its signature tart, lemony flavor. If you cannot find pomegranate molasses, substitute with 1 tsp balsamic vinegar and a pinch of sugar.',

    communityRating: 4.4,
    communityRatingCount: 175,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-15').toISOString(),
  },

  // ─── TURKISH (3) ────────────────────────────────────────────────────

  {
    title: 'Lamb Kofta',
    description:
      'Juicy, spiced ground lamb skewers grilled over high heat until charred outside and pink within. Served with a cool yogurt sauce and warm flatbread for a satisfying Turkish classic.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/lamb-kofta.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/lamb-kofta-prep.jpg', caption: 'Kofta mixture shaped onto skewers', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 20,
    cookTime: 12,
    totalTime: 32,
    difficulty: 'medium',
    spiceLevel: 2,

    cuisine: 'Turkish',
    region: 'Middle East',
    country: 'Turkey',

    categories: ['Dinner'],
    tags: ['high-protein', 'high-iron', 'low-carb', 'grilling', 'gluten-free', 'nut-free', 'under-30-min', 'date-night', 'weeknight-dinner'],

    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 520,
      protein: 32,
      carbs: 8,
      fat: 40,
      fiber: 2,
      sugar: 3,
      sodium: 640,
      iron: 4.2,
    },

    ingredients: [
      { qty: 1.5, unit: 'lb', item: 'ground lamb (80/20)', group: 'Kofta' },
      { qty: 1, unit: '', item: 'small yellow onion, grated and squeezed dry', group: 'Kofta' },
      { qty: 3, unit: '', item: 'garlic cloves, minced', group: 'Kofta' },
      { qty: 0.5, unit: 'cup', item: 'fresh parsley, finely chopped', group: 'Kofta' },
      { qty: 2, unit: 'tsp', item: 'ground cumin', group: 'Kofta' },
      { qty: 1, unit: 'tsp', item: 'ground coriander', group: 'Kofta' },
      { qty: 1, unit: 'tsp', item: 'smoked paprika', group: 'Kofta' },
      { qty: 0.5, unit: 'tsp', item: 'ground cinnamon', group: 'Kofta' },
      { qty: 0.25, unit: 'tsp', item: 'cayenne pepper', group: 'Kofta' },
      { qty: 1.5, unit: 'tsp', item: 'salt', group: 'Kofta' },
      { qty: 0.5, unit: 'tsp', item: 'black pepper', group: 'Kofta' },
      { qty: 1, unit: 'cup', item: 'plain Greek yogurt', group: 'Yogurt Sauce' },
      { qty: 1, unit: 'tbsp', item: 'lemon juice', group: 'Yogurt Sauce' },
      { qty: 1, unit: '', item: 'garlic clove, minced', group: 'Yogurt Sauce' },
      { qty: 0.25, unit: 'tsp', item: 'salt', group: 'Yogurt Sauce' },
      { qty: 2, unit: 'tbsp', item: 'fresh dill, chopped', group: 'Yogurt Sauce' },
    ],
    steps: [
      { order: 1, instruction: 'In a large bowl, combine ground lamb, grated onion, garlic, parsley, cumin, coriander, paprika, cinnamon, cayenne, salt, and pepper. Mix with your hands until the spices are evenly distributed -- do not overwork the meat.', timerMinutes: null },
      { order: 2, instruction: 'Divide the mixture into 8 portions. Shape each around a flat metal skewer into an elongated oval shape about 5 inches long. Refrigerate for 15 minutes to firm up.', timerMinutes: 15 },
      { order: 3, instruction: 'While the kofta chills, stir together Greek yogurt, lemon juice, garlic, salt, and dill. Refrigerate until serving.', timerMinutes: null },
      { order: 4, instruction: 'Preheat a grill or grill pan to high heat. Brush the grates lightly with oil.', timerMinutes: null },
      { order: 5, instruction: 'Grill the kofta for 4-5 minutes per side, turning once, until nicely charred on the outside and cooked through but still juicy (160 F internal temperature).', timerMinutes: 10 },
      { order: 6, instruction: 'Serve the kofta immediately with the yogurt-dill sauce, warm flatbread, and a simple salad of sliced onions, tomatoes, and sumac.', timerMinutes: null },
    ],
    notes: 'Grating and squeezing dry the onion is essential -- raw diced onion will make the kofta fall apart on the grill. If using wooden skewers, soak them in water for 30 minutes before grilling. These can also be shaped into patties and pan-fried.',

    communityRating: 4.6,
    communityRatingCount: 290,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-15').toISOString(),
  },

  {
    title: 'Lahmacun',
    description:
      'Paper-thin Turkish flatbreads topped with a spiced lamb and vegetable mixture, baked until crisp at the edges. Squeeze fresh lemon over the top, add parsley and pickled peppers, then roll up like a wrap.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/lahmacun.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/lahmacun-prep.jpg', caption: 'Spreading lamb topping onto rolled dough', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 40,
    cookTime: 10,
    totalTime: 50,
    difficulty: 'hard',
    spiceLevel: 2,

    cuisine: 'Turkish',
    region: 'Middle East',
    country: 'Turkey',

    categories: ['Dinner', 'Lunch'],
    tags: ['high-protein', 'high-iron', 'dairy-free', 'nut-free', 'baking', 'date-night', 'family-friendly'],

    ageGroups: ['kid', 'teen', 'adult'],

    nutrition: {
      calories: 410,
      protein: 24,
      carbs: 42,
      fat: 17,
      fiber: 3,
      sugar: 4,
      sodium: 580,
      iron: 4.0,
    },

    ingredients: [
      { qty: 2.5, unit: 'cups', item: 'all-purpose flour', group: 'Dough' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Dough' },
      { qty: 1, unit: 'tsp', item: 'sugar', group: 'Dough' },
      { qty: 1, unit: 'tsp', item: 'instant yeast', group: 'Dough' },
      { qty: 2, unit: 'tbsp', item: 'olive oil', group: 'Dough' },
      { qty: 0.75, unit: 'cup', item: 'warm water', group: 'Dough' },
      { qty: 0.75, unit: 'lb', item: 'ground lamb', group: 'Topping' },
      { qty: 1, unit: '', item: 'small yellow onion, finely diced', group: 'Topping' },
      { qty: 1, unit: '', item: 'green bell pepper, finely diced', group: 'Topping' },
      { qty: 2, unit: '', item: 'Roma tomatoes, finely diced', group: 'Topping' },
      { qty: 3, unit: '', item: 'garlic cloves, minced', group: 'Topping' },
      { qty: 2, unit: 'tbsp', item: 'tomato paste', group: 'Topping' },
      { qty: 1, unit: 'tbsp', item: 'red pepper paste (biber salcasi)', group: 'Topping' },
      { qty: 1, unit: 'tsp', item: 'ground cumin', group: 'Topping' },
      { qty: 1, unit: 'tsp', item: 'Aleppo pepper flakes', group: 'Topping' },
      { qty: 0.5, unit: 'tsp', item: 'smoked paprika', group: 'Topping' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Topping' },
      { qty: 0.5, unit: 'cup', item: 'fresh parsley, for serving', group: 'Serving' },
      { qty: 1, unit: '', item: 'lemon, cut into wedges', group: 'Serving' },
    ],
    steps: [
      { order: 1, instruction: 'Combine flour, salt, sugar, and yeast in a bowl. Add olive oil and warm water. Knead for 8-10 minutes until smooth and elastic. Cover with a damp towel and let rise for 45 minutes.', timerMinutes: 45 },
      { order: 2, instruction: 'Meanwhile, combine ground lamb, onion, bell pepper, tomatoes, garlic, tomato paste, red pepper paste, cumin, Aleppo pepper, paprika, and salt in a bowl. Mix thoroughly until the topping is spreadable and slightly paste-like.', timerMinutes: null },
      { order: 3, instruction: 'Preheat the oven to 500 F (or as high as it will go). Place a baking sheet or pizza stone in the oven to preheat.', timerMinutes: null },
      { order: 4, instruction: 'Divide the dough into 8 equal pieces. On a lightly floured surface, roll each piece paper-thin into a rough oval, about 10 inches long. The dough should be almost translucent.', timerMinutes: null },
      { order: 5, instruction: 'Spread a thin, even layer of the meat topping over each dough round, all the way to the edges. The layer should be very thin.', timerMinutes: null },
      { order: 6, instruction: 'Carefully transfer to the hot baking sheet or pizza stone. Bake for 4-5 minutes until the edges are crisp and the meat is cooked through.', timerMinutes: 5 },
      { order: 7, instruction: 'Remove from the oven, squeeze lemon juice over the top, scatter with fresh parsley, and roll up tightly. Serve immediately.', timerMinutes: null },
    ],
    notes: 'The key to authentic lahmacun is rolling the dough as thin as possible and keeping the meat layer thin. If you do not have red pepper paste, double the tomato paste and add an extra teaspoon of Aleppo pepper. Work in batches if needed.',

    communityRating: 4.5,
    communityRatingCount: 185,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-15').toISOString(),
  },

  {
    title: 'Turkish Eggs (Cilbir)',
    description:
      'Silky poached eggs nestled in a bed of cool, garlicky yogurt and drizzled with sizzling Aleppo pepper butter. A stunning Ottoman-era breakfast that is deceptively simple to prepare.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/turkish-eggs.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/turkish-eggs-prep.jpg', caption: 'Poaching eggs in simmering water', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 2,
    prepTime: 10,
    cookTime: 10,
    totalTime: 20,
    difficulty: 'easy',
    spiceLevel: 2,

    cuisine: 'Turkish',
    region: 'Middle East',
    country: 'Turkey',

    categories: ['Breakfast'],
    tags: ['vegetarian', 'high-protein', 'low-carb', 'gluten-free', 'nut-free', 'under-30-min', 'brunch', 'date-night'],

    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 350,
      protein: 18,
      carbs: 8,
      fat: 28,
      fiber: 1,
      sugar: 5,
      sodium: 480,
      iron: 2.4,
    },

    ingredients: [
      { qty: 1, unit: 'cup', item: 'plain full-fat Greek yogurt', group: 'Yogurt Base' },
      { qty: 1, unit: '', item: 'garlic clove, minced or grated', group: 'Yogurt Base' },
      { qty: 0.25, unit: 'tsp', item: 'salt', group: 'Yogurt Base' },
      { qty: 4, unit: '', item: 'large eggs', group: 'Eggs' },
      { qty: 1, unit: 'tbsp', item: 'white vinegar', group: 'Eggs' },
      { qty: 3, unit: 'tbsp', item: 'unsalted butter', group: 'Spiced Butter' },
      { qty: 1.5, unit: 'tsp', item: 'Aleppo pepper flakes (or 1 tsp paprika + pinch cayenne)', group: 'Spiced Butter' },
      { qty: 0.5, unit: 'tsp', item: 'smoked paprika', group: 'Spiced Butter' },
      { qty: 2, unit: 'tsp', item: 'fresh dill, chopped', group: 'Garnish' },
      { qty: 2, unit: '', item: 'slices crusty bread, for serving', group: 'Serving' },
    ],
    steps: [
      { order: 1, instruction: 'Stir together Greek yogurt, grated garlic, and salt. Divide between two shallow bowls and spread into an even layer. Set aside at room temperature while you prepare the eggs.', timerMinutes: null },
      { order: 2, instruction: 'Bring a medium pot of water to a gentle simmer. Add white vinegar. Create a gentle whirlpool and carefully crack the eggs in one at a time. Poach for 3-4 minutes until the whites are set and the yolks are still runny.', timerMinutes: 4 },
      { order: 3, instruction: 'While the eggs poach, melt butter in a small skillet over medium heat. Once it foams, add Aleppo pepper and smoked paprika. Swirl for 30 seconds until the butter turns a deep red and smells fragrant. Remove from heat immediately.', timerMinutes: null },
      { order: 4, instruction: 'Using a slotted spoon, carefully lift the poached eggs out of the water, blot gently on a paper towel, and nestle 2 eggs into each bowl of yogurt.', timerMinutes: null },
      { order: 5, instruction: 'Drizzle the sizzling spiced butter over the eggs and yogurt. Garnish with fresh dill and a small pinch of Aleppo pepper.', timerMinutes: null },
      { order: 6, instruction: 'Serve immediately with crusty bread for dipping and scooping.', timerMinutes: null },
    ],
    notes: 'The yogurt must be at room temperature, not cold from the fridge, or it will cool the eggs too quickly. For the prettiest poached eggs, use the freshest eggs you can find -- older eggs spread more in the water. Strain each egg through a fine-mesh sieve to remove wispy whites before poaching.',

    communityRating: 4.7,
    communityRatingCount: 310,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-15').toISOString(),
  },

  // ─── MOROCCAN (3) ───────────────────────────────────────────────────

  {
    title: 'Chicken Tagine',
    description:
      'A fragrant Moroccan stew of chicken thighs braised with preserved lemons, green olives, and a golden saffron-ginger broth. Slow-cooked in a conical tagine pot until the meat falls off the bone.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/chicken-tagine.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/chicken-tagine-prep.jpg', caption: 'Spiced chicken ready for braising', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 20,
    cookTime: 60,
    totalTime: 80,
    difficulty: 'medium',
    spiceLevel: 1,

    cuisine: 'Moroccan',
    region: 'Africa',
    country: 'Morocco',

    categories: ['Dinner', 'Soups & Stews'],
    tags: ['high-protein', 'high-iron', 'gluten-free', 'dairy-free', 'nut-free', 'one-pot', 'slow-cooker', 'comfort-food', 'sunday-dinner', 'make-ahead'],

    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 460,
      protein: 35,
      carbs: 14,
      fat: 30,
      fiber: 3,
      sugar: 4,
      sodium: 750,
      iron: 3.8,
    },

    ingredients: [
      { qty: 2.5, unit: 'lb', item: 'bone-in, skin-on chicken thighs', group: 'Chicken' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Chicken' },
      { qty: 0.5, unit: 'tsp', item: 'black pepper', group: 'Chicken' },
      { qty: 2, unit: 'tbsp', item: 'olive oil', group: 'Tagine' },
      { qty: 1, unit: '', item: 'large yellow onion, diced', group: 'Tagine' },
      { qty: 4, unit: '', item: 'garlic cloves, minced', group: 'Tagine' },
      { qty: 1, unit: 'tbsp', item: 'fresh ginger, grated', group: 'Tagine' },
      { qty: 1, unit: 'tsp', item: 'ground turmeric', group: 'Tagine' },
      { qty: 1, unit: 'tsp', item: 'ground cumin', group: 'Tagine' },
      { qty: 0.5, unit: 'tsp', item: 'ground cinnamon', group: 'Tagine' },
      { qty: 0.25, unit: 'tsp', item: 'saffron threads, crumbled', group: 'Tagine' },
      { qty: 1, unit: 'cup', item: 'chicken broth', group: 'Tagine' },
      { qty: 2, unit: '', item: 'preserved lemons, pulp discarded, rind thinly sliced', group: 'Tagine' },
      { qty: 1, unit: 'cup', item: 'green olives (Castelvetrano or picholine)', group: 'Tagine' },
      { qty: 0.5, unit: 'cup', item: 'fresh cilantro, chopped', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Season the chicken thighs generously with salt and pepper. Heat olive oil in a tagine, Dutch oven, or heavy-bottomed pot over medium-high heat. Sear the chicken skin-side down for 5 minutes until golden. Flip and sear 2 more minutes. Remove and set aside.', timerMinutes: 7 },
      { order: 2, instruction: 'In the same pot, add onion and cook for 5 minutes until softened. Add garlic and ginger, stirring for 1 minute until fragrant.', timerMinutes: 6 },
      { order: 3, instruction: 'Add turmeric, cumin, cinnamon, and saffron. Stir for 30 seconds to bloom the spices. Pour in the chicken broth and scrape up any browned bits from the bottom of the pot.', timerMinutes: null },
      { order: 4, instruction: 'Return the chicken to the pot, nestling it into the liquid. Add the preserved lemon rinds. Bring to a simmer, then reduce heat to low. Cover and cook for 40 minutes.', timerMinutes: 40 },
      { order: 5, instruction: 'Add the olives and cook uncovered for an additional 10 minutes to let the sauce reduce and thicken slightly.', timerMinutes: 10 },
      { order: 6, instruction: 'Taste the sauce and adjust salt if needed. Garnish with fresh cilantro and serve over couscous or with crusty bread.', timerMinutes: null },
    ],
    notes: 'Preserved lemons are not optional -- they define this dish. Find them at Middle Eastern grocers or make your own 4 weeks ahead with just lemons and salt. If using a slow cooker, sear the chicken first, then cook on low for 6 hours.',

    communityRating: 4.8,
    communityRatingCount: 350,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-15').toISOString(),
  },

  {
    title: 'Harira',
    description:
      'A hearty Moroccan soup traditionally served to break the Ramadan fast, brimming with chickpeas, lentils, tender lamb, and a tomato broth perfumed with cinnamon and ginger.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/harira.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/harira-prep.jpg', caption: 'Soup base with tomatoes and lentils simmering', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 15,
    cookTime: 60,
    totalTime: 75,
    difficulty: 'easy',
    spiceLevel: 1,

    cuisine: 'Moroccan',
    region: 'Africa',
    country: 'Morocco',

    categories: ['Soups & Stews', 'Dinner'],
    tags: ['high-protein', 'high-fiber', 'high-iron', 'dairy-free', 'nut-free', 'one-pot', 'freezer-friendly', 'batch-cooking', 'comfort-food', 'budget-friendly'],

    ageGroups: ['kid', 'teen', 'adult'],

    nutrition: {
      calories: 380,
      protein: 28,
      carbs: 38,
      fat: 13,
      fiber: 10,
      sugar: 7,
      sodium: 690,
      iron: 5.8,
    },

    ingredients: [
      { qty: 1, unit: 'lb', item: 'lamb shoulder, cut into small cubes', group: 'Soup' },
      { qty: 2, unit: 'tbsp', item: 'olive oil', group: 'Soup' },
      { qty: 1, unit: '', item: 'large yellow onion, diced', group: 'Soup' },
      { qty: 4, unit: '', item: 'celery stalks, diced', group: 'Soup' },
      { qty: 4, unit: '', item: 'garlic cloves, minced', group: 'Soup' },
      { qty: 1, unit: 'tsp', item: 'ground ginger', group: 'Soup' },
      { qty: 1, unit: 'tsp', item: 'ground turmeric', group: 'Soup' },
      { qty: 1, unit: 'tsp', item: 'ground cinnamon', group: 'Soup' },
      { qty: 0.5, unit: 'tsp', item: 'black pepper', group: 'Soup' },
      { qty: 1, unit: '14-oz can', item: 'crushed tomatoes', group: 'Soup' },
      { qty: 2, unit: 'tbsp', item: 'tomato paste', group: 'Soup' },
      { qty: 6, unit: 'cups', item: 'water or beef broth', group: 'Soup' },
      { qty: 0.75, unit: 'cup', item: 'green or brown lentils, rinsed', group: 'Soup' },
      { qty: 1, unit: '15-oz can', item: 'chickpeas, drained and rinsed', group: 'Soup' },
      { qty: 0.5, unit: 'cup', item: 'vermicelli or angel hair pasta, broken into pieces', group: 'Soup' },
      { qty: 0.5, unit: 'cup', item: 'fresh cilantro, chopped', group: 'Garnish' },
      { qty: 0.5, unit: 'cup', item: 'fresh parsley, chopped', group: 'Garnish' },
      { qty: 2, unit: 'tbsp', item: 'lemon juice', group: 'Garnish' },
      { qty: 1.5, unit: 'tsp', item: 'salt', group: 'Soup' },
    ],
    steps: [
      { order: 1, instruction: 'Heat olive oil in a large pot over medium-high heat. Add the lamb cubes and brown on all sides, about 5 minutes. Do not crowd the pot -- work in batches if needed.', timerMinutes: 5 },
      { order: 2, instruction: 'Add onion and celery to the pot with the lamb. Cook for 5 minutes until softened. Add garlic, ginger, turmeric, cinnamon, and black pepper. Stir for 1 minute until fragrant.', timerMinutes: 6 },
      { order: 3, instruction: 'Add crushed tomatoes, tomato paste, and water or broth. Stir well, bring to a boil, then reduce to a simmer. Add lentils. Cover and cook for 35 minutes until the lentils and lamb are tender.', timerMinutes: 35 },
      { order: 4, instruction: 'Add chickpeas and broken vermicelli. Cook uncovered for 10 more minutes until the pasta is tender and the soup has thickened.', timerMinutes: 10 },
      { order: 5, instruction: 'Stir in the fresh cilantro, parsley, lemon juice, and salt. Taste and adjust seasoning.', timerMinutes: null },
      { order: 6, instruction: 'Ladle into bowls and serve with warm crusty bread and lemon wedges on the side.', timerMinutes: null },
    ],
    notes: 'This soup thickens considerably as it sits. Add extra broth when reheating. For a vegetarian version, omit the lamb, use vegetable broth, and double the lentils. Harira freezes exceptionally well for up to 3 months.',

    communityRating: 4.6,
    communityRatingCount: 240,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-15').toISOString(),
  },

  {
    title: 'Moroccan Couscous',
    description:
      'Fluffy steamed couscous crowned with a fragrant stew of seven vegetables, chickpeas, and tender lamb -- the undisputed national dish of Morocco served every Friday in homes across the country.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/moroccan-couscous.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/moroccan-couscous-prep.jpg', caption: 'Vegetables and broth simmering', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 25,
    cookTime: 65,
    totalTime: 90,
    difficulty: 'medium',
    spiceLevel: 1,

    cuisine: 'Moroccan',
    region: 'Africa',
    country: 'Morocco',

    categories: ['Dinner'],
    tags: ['high-protein', 'high-fiber', 'high-iron', 'dairy-free', 'nut-free', 'one-pot', 'sunday-dinner', 'family-friendly', 'celebration'],

    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 560,
      protein: 32,
      carbs: 65,
      fat: 18,
      fiber: 10,
      sugar: 12,
      sodium: 720,
      iron: 5.2,
    },

    ingredients: [
      { qty: 1.5, unit: 'lb', item: 'lamb shoulder, cut into large chunks', group: 'Stew' },
      { qty: 2, unit: 'tbsp', item: 'olive oil', group: 'Stew' },
      { qty: 1, unit: '', item: 'large yellow onion, quartered', group: 'Stew' },
      { qty: 3, unit: '', item: 'garlic cloves, minced', group: 'Stew' },
      { qty: 1, unit: 'tsp', item: 'ground turmeric', group: 'Stew' },
      { qty: 1, unit: 'tsp', item: 'ground ginger', group: 'Stew' },
      { qty: 0.5, unit: 'tsp', item: 'ground cinnamon', group: 'Stew' },
      { qty: 0.25, unit: 'tsp', item: 'saffron threads', group: 'Stew' },
      { qty: 1.5, unit: 'tsp', item: 'salt', group: 'Stew' },
      { qty: 6, unit: 'cups', item: 'water', group: 'Stew' },
      { qty: 3, unit: '', item: 'carrots, peeled and cut into large chunks', group: 'Vegetables' },
      { qty: 2, unit: '', item: 'turnips, peeled and quartered', group: 'Vegetables' },
      { qty: 2, unit: '', item: 'zucchini, cut into large pieces', group: 'Vegetables' },
      { qty: 1, unit: 'lb', item: 'butternut squash, peeled and cubed', group: 'Vegetables' },
      { qty: 1, unit: '', item: 'small cabbage, cut into wedges', group: 'Vegetables' },
      { qty: 2, unit: '', item: 'Roma tomatoes, quartered', group: 'Vegetables' },
      { qty: 1, unit: '15-oz can', item: 'chickpeas, drained and rinsed', group: 'Vegetables' },
      { qty: 2, unit: 'cups', item: 'dry couscous', group: 'Couscous' },
      { qty: 2, unit: 'tbsp', item: 'butter', group: 'Couscous' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Couscous' },
    ],
    steps: [
      { order: 1, instruction: 'Heat olive oil in a large pot or the bottom of a couscoussier over medium-high heat. Brown the lamb chunks on all sides, about 6 minutes total. Add onion and garlic, cooking 3 more minutes.', timerMinutes: 9 },
      { order: 2, instruction: 'Add turmeric, ginger, cinnamon, saffron, and salt. Stir for 30 seconds. Pour in the water and bring to a boil. Reduce to a simmer, cover, and cook for 30 minutes until the lamb starts to become tender.', timerMinutes: 30 },
      { order: 3, instruction: 'Add carrots and turnips to the pot. Cook for 10 minutes. Then add butternut squash, cabbage, and tomatoes. Cook for another 15 minutes until all vegetables are tender but not mushy.', timerMinutes: 25 },
      { order: 4, instruction: 'Add chickpeas and zucchini in the last 5 minutes of cooking (zucchini overcooks quickly).', timerMinutes: 5 },
      { order: 5, instruction: 'While the stew finishes, place couscous in a large bowl. Ladle 2 cups of the hot broth from the stew over the couscous. Add butter and salt, stir, and cover tightly with plastic wrap. Let stand for 10 minutes, then fluff with a fork.', timerMinutes: 10 },
      { order: 6, instruction: 'Mound the couscous on a large serving platter. Arrange the lamb and vegetables on top. Ladle some broth over everything. Serve the remaining broth on the side in a bowl.', timerMinutes: null },
    ],
    notes: 'Traditionally, the couscous is steamed above the stew in a couscoussier, a two-tiered pot. The instant couscous method here is much faster and nearly as good. Feel free to vary the vegetables with the seasons -- this is a flexible dish.',

    communityRating: 4.5,
    communityRatingCount: 195,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-15').toISOString(),
  },

  // ─── ETHIOPIAN (3) ──────────────────────────────────────────────────

  {
    title: 'Doro Wat',
    description:
      'Ethiopia\'s iconic spicy chicken stew, simmered in a deep berbere-spiced sauce with caramelized onions and finished with hard-boiled eggs. The queen of Ethiopian cuisine and the centerpiece of any holiday feast.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/doro-wat.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/doro-wat-prep.jpg', caption: 'Caramelizing onions for the base', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 20,
    cookTime: 75,
    totalTime: 95,
    difficulty: 'hard',
    spiceLevel: 4,

    cuisine: 'Ethiopian',
    region: 'Africa',
    country: 'Ethiopia',

    categories: ['Dinner', 'Soups & Stews'],
    tags: ['high-protein', 'high-iron', 'gluten-free', 'dairy-free', 'nut-free', 'one-pot', 'slow-cooker', 'comfort-food', 'sunday-dinner', 'celebration'],

    ageGroups: ['adult'],

    nutrition: {
      calories: 510,
      protein: 42,
      carbs: 18,
      fat: 30,
      fiber: 4,
      sugar: 7,
      sodium: 780,
      iron: 5.5,
    },

    ingredients: [
      { qty: 2.5, unit: 'lb', item: 'chicken legs and thighs (bone-in, skin removed)', group: 'Chicken' },
      { qty: 2, unit: 'tbsp', item: 'lemon juice', group: 'Chicken' },
      { qty: 1.5, unit: 'tsp', item: 'salt', group: 'Chicken' },
      { qty: 4, unit: '', item: 'large red onions, finely diced', group: 'Stew' },
      { qty: 0.25, unit: 'cup', item: 'niter kibbeh (Ethiopian spiced butter) or clarified butter', group: 'Stew' },
      { qty: 4, unit: '', item: 'garlic cloves, minced', group: 'Stew' },
      { qty: 1, unit: 'tbsp', item: 'fresh ginger, grated', group: 'Stew' },
      { qty: 3, unit: 'tbsp', item: 'berbere spice blend', group: 'Stew' },
      { qty: 1, unit: 'tbsp', item: 'tomato paste', group: 'Stew' },
      { qty: 0.5, unit: 'cup', item: 'water', group: 'Stew' },
      { qty: 0.25, unit: 'tsp', item: 'ground cardamom', group: 'Stew' },
      { qty: 0.25, unit: 'tsp', item: 'ground fenugreek', group: 'Stew' },
      { qty: 4, unit: '', item: 'hard-boiled eggs, peeled and scored with a fork', group: 'Eggs' },
    ],
    steps: [
      { order: 1, instruction: 'Rub chicken pieces with lemon juice and 1 tsp salt. Set aside while you prepare the onion base.', timerMinutes: null },
      { order: 2, instruction: 'In a large, dry pot over medium heat, cook the diced onions, stirring frequently, for 15-20 minutes. Do not add oil -- the onions will slowly release their own moisture and caramelize deeply. This step is critical and cannot be rushed.', timerMinutes: 20 },
      { order: 3, instruction: 'Once the onions are deeply golden and jammy, add the niter kibbeh. Stir in garlic and ginger, cooking for 2 minutes. Add berbere spice and tomato paste, stirring constantly for 3-4 minutes until the spice mixture is fragrant and the oil starts to separate.', timerMinutes: 6 },
      { order: 4, instruction: 'Add water to the pot, scraping up any browned bits. Stir in cardamom, fenugreek, and remaining salt. Bring to a simmer.', timerMinutes: null },
      { order: 5, instruction: 'Add the chicken pieces, turning to coat in the sauce. Cover and simmer on low heat for 45 minutes, turning the chicken once halfway through, until very tender and the sauce has thickened.', timerMinutes: 45 },
      { order: 6, instruction: 'Score each hard-boiled egg a few times with a fork so the sauce can penetrate. Nestle the eggs into the stew and cook for a final 5-10 minutes.', timerMinutes: 10 },
      { order: 7, instruction: 'Serve the doro wat on a large plate lined with injera, with the eggs nestled around the chicken. Offer additional injera on the side for scooping.', timerMinutes: null },
    ],
    notes: 'The dry-caramelized onion base is the foundation of all great Ethiopian stews and cannot be shortcut. Berbere spice blend can be found at Ethiopian grocers or made from scratch with chili peppers, fenugreek, coriander, and many other spices. Niter kibbeh can be substituted with regular clarified butter.',

    communityRating: 4.7,
    communityRatingCount: 265,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-15').toISOString(),
  },

  {
    title: 'Misir Wat (Red Lentils)',
    description:
      'A warmly spiced Ethiopian red lentil stew cooked down into a luscious, creamy consistency with berbere and caramelized onions. A comforting vegan staple found on every Ethiopian combination platter.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/misir-wat.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/misir-wat-prep.jpg', caption: 'Red lentils and spices measured out', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 10,
    cookTime: 40,
    totalTime: 50,
    difficulty: 'easy',
    spiceLevel: 3,

    cuisine: 'Ethiopian',
    region: 'Africa',
    country: 'Ethiopia',

    categories: ['Dinner', 'Soups & Stews', 'Sides'],
    tags: ['vegan', 'high-protein', 'high-fiber', 'high-iron', 'gluten-free', 'dairy-free', 'nut-free', 'one-pot', 'budget-friendly', 'pantry-staples', 'comfort-food', 'meal-prep'],

    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 310,
      protein: 18,
      carbs: 44,
      fat: 8,
      fiber: 12,
      sugar: 5,
      sodium: 560,
      iron: 6.2,
    },

    ingredients: [
      { qty: 2, unit: '', item: 'large red onions, finely diced', group: 'Stew' },
      { qty: 2, unit: 'tbsp', item: 'vegetable oil', group: 'Stew' },
      { qty: 3, unit: '', item: 'garlic cloves, minced', group: 'Stew' },
      { qty: 1, unit: 'tbsp', item: 'fresh ginger, grated', group: 'Stew' },
      { qty: 2, unit: 'tbsp', item: 'berbere spice blend', group: 'Stew' },
      { qty: 1, unit: 'tbsp', item: 'tomato paste', group: 'Stew' },
      { qty: 1.5, unit: 'cups', item: 'red lentils, rinsed and drained', group: 'Stew' },
      { qty: 3.5, unit: 'cups', item: 'water', group: 'Stew' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Stew' },
      { qty: 0.5, unit: 'tsp', item: 'ground turmeric', group: 'Stew' },
    ],
    steps: [
      { order: 1, instruction: 'In a large pot over medium heat, cook the diced onions dry (without oil) for 12-15 minutes, stirring frequently, until deeply caramelized and jammy. This slow dry cooking builds the characteristic deep flavor.', timerMinutes: 15 },
      { order: 2, instruction: 'Add the vegetable oil, garlic, and ginger. Cook for 2 minutes until fragrant. Add berbere spice and tomato paste, stirring constantly for 2-3 minutes until the spice mixture darkens and the oil begins to separate.', timerMinutes: 5 },
      { order: 3, instruction: 'Add the rinsed red lentils, water, salt, and turmeric. Stir well to combine. Bring to a boil, then reduce heat to low.', timerMinutes: null },
      { order: 4, instruction: 'Simmer uncovered for 20-25 minutes, stirring occasionally to prevent sticking, until the lentils have completely broken down into a thick, creamy stew. Add more water if needed.', timerMinutes: 25 },
      { order: 5, instruction: 'Taste and adjust salt and berbere to your preference. The stew should be thick enough to scoop with injera but not stiff.', timerMinutes: null },
      { order: 6, instruction: 'Serve warm on a platter of injera alongside other Ethiopian dishes, or over rice.', timerMinutes: null },
    ],
    notes: 'Red lentils break down completely when cooked, which is exactly what you want here -- no need to worry about them holding their shape. The heat level depends entirely on your berbere blend; start with less and add more if desired. This stew tastes even better the next day.',

    communityRating: 4.5,
    communityRatingCount: 225,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-15').toISOString(),
  },

  {
    title: 'Injera',
    description:
      'Ethiopia\'s spongy, sourdough flatbread with a distinctive tangy flavor and honeycomb surface. Made from teff flour and naturally fermented for several days, it serves as both plate and utensil in Ethiopian cuisine.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/injera.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/injera-prep.jpg', caption: 'Pouring batter in a spiral onto the pan', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 15,
    cookTime: 30,
    totalTime: 45,
    difficulty: 'hard',
    spiceLevel: 0,

    cuisine: 'Ethiopian',
    region: 'Africa',
    country: 'Ethiopia',

    categories: ['Sides', 'Baking'],
    tags: ['vegan', 'high-iron', 'high-fiber', 'gluten-free', 'dairy-free', 'nut-free', 'egg-free'],

    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 170,
      protein: 6,
      carbs: 34,
      fat: 1,
      fiber: 4,
      sugar: 1,
      sodium: 220,
      iron: 4.8,
    },

    ingredients: [
      { qty: 2, unit: 'cups', item: 'teff flour (preferably dark)', group: 'Batter' },
      { qty: 2.5, unit: 'cups', item: 'water, room temperature', group: 'Batter' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Batter' },
    ],
    steps: [
      { order: 1, instruction: 'Three days before you plan to cook: Whisk teff flour and water together in a large bowl until smooth. Cover loosely with a cloth or plastic wrap and set in a warm spot (75-80 F) for 2-3 days. The batter will bubble and develop a sour, tangy aroma similar to sourdough.', timerMinutes: null },
      { order: 2, instruction: 'When the batter has fermented and smells pleasantly sour (2-3 days), carefully pour off any liquid that has risen to the top. Stir in the salt. The batter should have the consistency of thin crepe batter -- add a splash of water if too thick.', timerMinutes: null },
      { order: 3, instruction: 'Heat a large (10-12 inch) non-stick skillet or injera pan (mitad) over medium heat. Do not oil the pan.', timerMinutes: null },
      { order: 4, instruction: 'Pour about 1/3 cup of batter onto the pan, starting from the outside edge and spiraling toward the center in a single thin layer. The batter should cover the surface without gaps.', timerMinutes: null },
      { order: 5, instruction: 'Cover the pan immediately. Cook for 2-3 minutes. The injera is done when the surface is dry, the edges lift from the pan, and you see the characteristic "eyes" (small holes) across the surface. Do not flip it.', timerMinutes: 3 },
      { order: 6, instruction: 'Gently remove the injera to a plate or clean cloth. Repeat with the remaining batter, stacking the injera with parchment paper between them. Let cool before serving.', timerMinutes: null },
    ],
    notes: 'Patience with the fermentation is essential -- 3 days at warm room temperature gives the best sour flavor and the most bubbles. If you are short on time, add 1 tsp of apple cider vinegar to the batter for a quick tang, but the texture will not be as authentic. Teff flour can be found at health food stores or Ethiopian grocers. Note: Prep time does not include the 2-3 day fermentation period.',

    communityRating: 3.9,
    communityRatingCount: 115,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-15').toISOString(),
  },

  // ─── PERSIAN (2) ────────────────────────────────────────────────────

  {
    title: 'Tahdig',
    description:
      'The crown jewel of Persian rice cookery -- a golden, impossibly crispy crust of saffron-scented rice that forms on the bottom of the pot. The dramatic flip onto a platter is a moment of pure culinary theater.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/tahdig.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/tahdig-prep.jpg', caption: 'Rice parboiling in salted water', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 15,
    cookTime: 60,
    totalTime: 75,
    difficulty: 'hard',
    spiceLevel: 0,

    cuisine: 'Persian',
    region: 'Middle East',
    country: 'Iran',

    categories: ['Sides', 'Dinner'],
    tags: ['gluten-free', 'vegetarian', 'nut-free', 'egg-free', 'comfort-food', 'celebration', 'sunday-dinner'],

    ageGroups: ['kid', 'teen', 'adult'],

    nutrition: {
      calories: 340,
      protein: 5,
      carbs: 56,
      fat: 11,
      fiber: 1,
      sugar: 0,
      sodium: 380,
      iron: 1.2,
    },

    ingredients: [
      { qty: 2, unit: 'cups', item: 'long-grain basmati rice', group: 'Rice' },
      { qty: 8, unit: 'cups', item: 'water, for soaking and parboiling', group: 'Rice' },
      { qty: 2, unit: 'tbsp', item: 'salt (for parboiling water)', group: 'Rice' },
      { qty: 0.25, unit: 'tsp', item: 'saffron threads, crumbled', group: 'Saffron' },
      { qty: 2, unit: 'tbsp', item: 'hot water', group: 'Saffron' },
      { qty: 3, unit: 'tbsp', item: 'unsalted butter', group: 'Cooking' },
      { qty: 2, unit: 'tbsp', item: 'vegetable oil', group: 'Cooking' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Cooking' },
    ],
    steps: [
      { order: 1, instruction: 'Rinse the rice in several changes of cold water until the water runs clear. Soak in cold water with 1 tbsp salt for at least 30 minutes (up to 2 hours). Drain.', timerMinutes: 30 },
      { order: 2, instruction: 'Bloom the saffron by steeping the crumbled threads in 2 tbsp hot water. Set aside -- it will deepen in color as it sits.', timerMinutes: null },
      { order: 3, instruction: 'Bring 6 cups of water to a rolling boil with 1 tbsp salt. Add the drained rice and parboil for 5-6 minutes -- the rice should be soft on the outside but still firm in the center (al dente). Drain in a colander and rinse briefly with cool water to stop cooking.', timerMinutes: 6 },
      { order: 4, instruction: 'In a non-stick pot or Dutch oven, melt butter with the vegetable oil over medium heat. Add saffron water and 0.5 tsp salt. Swirl to coat the bottom evenly.', timerMinutes: null },
      { order: 5, instruction: 'Spoon a layer of parboiled rice into the pot, gently pressing it into the butter to form a flat, even crust layer about 1 inch thick. Mound the remaining rice on top in a pyramid shape without pressing. Poke 5-6 holes through the rice to the bottom with the handle of a wooden spoon to allow steam to escape.', timerMinutes: null },
      { order: 6, instruction: 'Wrap the pot lid in a clean kitchen towel (to absorb steam) and place on the pot. Cook on medium heat for 8 minutes until you hear a gentle sizzle, then reduce to the lowest heat setting and cook for 45-50 minutes.', timerMinutes: 50 },
      { order: 7, instruction: 'Place the pot on a cold, wet towel for 2 minutes to help release the crust. Invert a large plate over the pot and flip confidently in one swift motion. Lift the pot to reveal the golden tahdig. Serve immediately.', timerMinutes: 2 },
    ],
    notes: 'The towel-wrapped lid is essential to prevent condensation from dripping back and making the rice soggy. For potato tahdig, layer thinly sliced potatoes on the bottom instead of rice. Lavash bread tahdig is another popular variation. Do not be tempted to peek during cooking -- trust the process.',

    communityRating: 4.9,
    communityRatingCount: 440,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-15').toISOString(),
  },

  {
    title: 'Ghormeh Sabzi',
    description:
      'Iran\'s beloved herb stew -- an intensely aromatic braise of kidney beans, lamb, and a mountain of fresh herbs with dried fenugreek and tart dried limes. Often called the national dish of Iran.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/ghormeh-sabzi.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/ghormeh-sabzi-prep.jpg', caption: 'Fresh herbs chopped and ready for sauteing', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 30,
    cookTime: 120,
    totalTime: 150,
    difficulty: 'hard',
    spiceLevel: 1,

    cuisine: 'Persian',
    region: 'Middle East',
    country: 'Iran',

    categories: ['Dinner', 'Soups & Stews'],
    tags: ['high-protein', 'high-fiber', 'high-iron', 'gluten-free', 'dairy-free', 'nut-free', 'one-pot', 'make-ahead', 'freezer-friendly', 'comfort-food', 'sunday-dinner'],

    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 430,
      protein: 34,
      carbs: 24,
      fat: 22,
      fiber: 8,
      sugar: 3,
      sodium: 650,
      iron: 7.2,
    },

    ingredients: [
      { qty: 1.5, unit: 'lb', item: 'lamb stew meat (shoulder), cubed', group: 'Stew' },
      { qty: 3, unit: 'tbsp', item: 'vegetable oil, divided', group: 'Stew' },
      { qty: 1, unit: '', item: 'large yellow onion, finely diced', group: 'Stew' },
      { qty: 0.5, unit: 'tsp', item: 'ground turmeric', group: 'Stew' },
      { qty: 1.5, unit: 'tsp', item: 'salt', group: 'Stew' },
      { qty: 0.5, unit: 'tsp', item: 'black pepper', group: 'Stew' },
      { qty: 2, unit: 'cups', item: 'water', group: 'Stew' },
      { qty: 3, unit: 'cups', item: 'fresh parsley, finely chopped', group: 'Herbs' },
      { qty: 1.5, unit: 'cups', item: 'fresh cilantro, finely chopped', group: 'Herbs' },
      { qty: 1, unit: 'cup', item: 'fresh chives or green onion tops, chopped', group: 'Herbs' },
      { qty: 0.5, unit: 'cup', item: 'fresh fenugreek leaves, chopped (or 3 tbsp dried)', group: 'Herbs' },
      { qty: 3, unit: '', item: 'dried limes (limoo amani), pierced with a knife', group: 'Flavoring' },
      { qty: 1, unit: '15-oz can', item: 'red kidney beans, drained and rinsed', group: 'Beans' },
      { qty: 2, unit: 'tbsp', item: 'lime juice', group: 'Flavoring' },
    ],
    steps: [
      { order: 1, instruction: 'Heat 2 tbsp oil in a large pot over medium-high heat. Brown the lamb cubes in batches, about 3 minutes per side. Remove and set aside.', timerMinutes: 8 },
      { order: 2, instruction: 'Add the remaining 1 tbsp oil and cook the diced onion for 5 minutes until golden. Add turmeric and stir for 30 seconds. Return the lamb to the pot along with salt, pepper, and water. Bring to a boil, then reduce heat to low. Cover and simmer for 45 minutes.', timerMinutes: 45 },
      { order: 3, instruction: 'While the lamb simmers, heat a skillet over medium-high heat with a splash of oil. Saute the chopped parsley, cilantro, chives, and fenugreek for 10-15 minutes, stirring frequently, until the herbs are dark green and fragrant. This step is critical -- it deepens the herb flavor and prevents the stew from tasting "grassy."', timerMinutes: 15 },
      { order: 4, instruction: 'Add the sauteed herbs and pierced dried limes to the lamb pot. Continue simmering, covered, for another 45 minutes.', timerMinutes: 45 },
      { order: 5, instruction: 'Add the kidney beans and lime juice. Simmer uncovered for 15-20 more minutes until the sauce is thick and the lamb is very tender.', timerMinutes: 20 },
      { order: 6, instruction: 'Taste and adjust salt and lime juice. The stew should be tangy, herbaceous, and thick. Serve over steamed basmati rice (ideally with tahdig).', timerMinutes: null },
    ],
    notes: 'Ghormeh sabzi always tastes better the next day, so this is an ideal make-ahead dish. Dried limes are available at Persian or Middle Eastern grocers and are essential for the distinctive sour flavor. If you cannot find fresh fenugreek, dried fenugreek (shambalileh) works well. Freeze in portions for up to 3 months.',

    communityRating: 4.8,
    communityRatingCount: 360,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-15').toISOString(),
  },

  // ─── ISRAELI (1) ────────────────────────────────────────────────────

  {
    title: 'Shakshuka',
    description:
      'Eggs poached in a spiced, smoky tomato and pepper sauce, served bubbling straight from the skillet with crusty bread for dipping. A beloved breakfast staple that has conquered brunch menus worldwide.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/shakshuka.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/shakshuka-prep.jpg', caption: 'Tomato sauce simmering before adding eggs', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 10,
    cookTime: 25,
    totalTime: 35,
    difficulty: 'easy',
    spiceLevel: 2,

    cuisine: 'Israeli',
    region: 'Middle East',
    country: 'Israel',

    categories: ['Breakfast', 'Dinner'],
    tags: ['vegetarian', 'high-protein', 'high-iron', 'gluten-free', 'dairy-free', 'nut-free', 'one-pan', 'under-30-min', 'budget-friendly', 'weeknight-dinner', 'brunch', 'comfort-food'],

    ageGroups: ['kid', 'teen', 'adult'],

    nutrition: {
      calories: 280,
      protein: 16,
      carbs: 18,
      fat: 17,
      fiber: 4,
      sugar: 9,
      sodium: 620,
      iron: 4.0,
    },

    ingredients: [
      { qty: 2, unit: 'tbsp', item: 'olive oil', group: 'Sauce' },
      { qty: 1, unit: '', item: 'large yellow onion, diced', group: 'Sauce' },
      { qty: 1, unit: '', item: 'red bell pepper, diced', group: 'Sauce' },
      { qty: 4, unit: '', item: 'garlic cloves, minced', group: 'Sauce' },
      { qty: 1, unit: 'tsp', item: 'ground cumin', group: 'Sauce' },
      { qty: 1, unit: 'tsp', item: 'smoked paprika', group: 'Sauce' },
      { qty: 0.5, unit: 'tsp', item: 'cayenne pepper', group: 'Sauce' },
      { qty: 1, unit: '28-oz can', item: 'whole peeled tomatoes, crushed by hand', group: 'Sauce' },
      { qty: 1, unit: 'tbsp', item: 'tomato paste', group: 'Sauce' },
      { qty: 1, unit: 'tsp', item: 'sugar', group: 'Sauce' },
      { qty: 1, unit: 'tsp', item: 'salt', group: 'Sauce' },
      { qty: 0.5, unit: 'tsp', item: 'black pepper', group: 'Sauce' },
      { qty: 6, unit: '', item: 'large eggs', group: 'Eggs' },
      { qty: 0.25, unit: 'cup', item: 'fresh parsley, chopped', group: 'Garnish' },
      { qty: 2, unit: 'oz', item: 'feta cheese, crumbled (optional)', group: 'Garnish' },
      { qty: 4, unit: '', item: 'slices crusty bread, for serving', group: 'Serving' },
    ],
    steps: [
      { order: 1, instruction: 'Heat olive oil in a large (12-inch) skillet over medium heat. Add onion and bell pepper. Cook for 7-8 minutes, stirring occasionally, until softened and lightly golden.', timerMinutes: 8 },
      { order: 2, instruction: 'Add garlic, cumin, smoked paprika, and cayenne. Stir for 1 minute until very fragrant.', timerMinutes: 1 },
      { order: 3, instruction: 'Add the crushed tomatoes, tomato paste, sugar, salt, and pepper. Stir well and simmer for 8-10 minutes until the sauce thickens slightly and the flavors meld.', timerMinutes: 10 },
      { order: 4, instruction: 'Using the back of a spoon, make 6 wells in the sauce. Crack one egg into each well. Season the eggs lightly with salt and pepper.', timerMinutes: null },
      { order: 5, instruction: 'Cover the skillet and cook on medium-low for 5-8 minutes until the egg whites are fully set but the yolks are still runny (or to your preference).', timerMinutes: 7 },
      { order: 6, instruction: 'Remove from heat. Scatter with fresh parsley and crumbled feta if using. Serve immediately in the skillet with crusty bread for dipping.', timerMinutes: null },
    ],
    notes: 'For the best runny yolks, watch the eggs carefully once covered -- they can go from runny to hard very quickly. Some people crack the eggs into a small bowl first to avoid breaking the yolks. The feta is optional but adds a creamy, salty contrast. Leftovers (without eggs) make an excellent pasta sauce.',

    communityRating: 4.8,
    communityRatingCount: 450,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-15').toISOString(),
  },

  // ─── NIGERIAN (1) ───────────────────────────────────────────────────

  {
    title: 'Jollof Rice',
    description:
      'West Africa\'s most famous one-pot rice dish, cooked in a rich, smoky tomato-pepper sauce until each grain is deeply stained and infused with flavor. The smoky bottom crust is the prized party piece.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/jollof-rice.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/jollof-rice-prep.jpg', caption: 'Blended tomato and pepper base', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 20,
    cookTime: 50,
    totalTime: 70,
    difficulty: 'medium',
    spiceLevel: 3,

    cuisine: 'Nigerian',
    region: 'Africa',
    country: 'Nigeria',

    categories: ['Dinner', 'Sides'],
    tags: ['high-iron', 'gluten-free', 'dairy-free', 'nut-free', 'one-pot', 'batch-cooking', 'party', 'family-friendly', 'celebration'],

    ageGroups: ['kid', 'teen', 'adult'],

    nutrition: {
      calories: 420,
      protein: 8,
      carbs: 62,
      fat: 16,
      fiber: 3,
      sugar: 7,
      sodium: 580,
      iron: 3.5,
    },

    ingredients: [
      { qty: 3, unit: 'cups', item: 'long-grain parboiled rice (not basmati)', group: 'Rice' },
      { qty: 6, unit: '', item: 'Roma tomatoes, quartered', group: 'Tomato Base' },
      { qty: 1, unit: '6-oz can', item: 'tomato paste', group: 'Tomato Base' },
      { qty: 3, unit: '', item: 'red bell peppers, seeded and quartered', group: 'Tomato Base' },
      { qty: 2, unit: '', item: 'habanero or scotch bonnet peppers (seeds removed for less heat)', group: 'Tomato Base' },
      { qty: 1, unit: '', item: 'large red onion, quartered', group: 'Tomato Base' },
      { qty: 0.33, unit: 'cup', item: 'vegetable oil', group: 'Cooking' },
      { qty: 1, unit: '', item: 'large yellow onion, thinly sliced', group: 'Cooking' },
      { qty: 3, unit: '', item: 'garlic cloves, minced', group: 'Cooking' },
      { qty: 1, unit: 'tbsp', item: 'fresh ginger, grated', group: 'Cooking' },
      { qty: 2, unit: 'tsp', item: 'curry powder', group: 'Seasoning' },
      { qty: 1, unit: 'tsp', item: 'dried thyme', group: 'Seasoning' },
      { qty: 2, unit: '', item: 'bay leaves', group: 'Seasoning' },
      { qty: 1, unit: '', item: 'chicken or vegetable bouillon cube', group: 'Seasoning' },
      { qty: 1.5, unit: 'tsp', item: 'salt', group: 'Seasoning' },
      { qty: 1, unit: 'cup', item: 'chicken or vegetable broth', group: 'Cooking' },
    ],
    steps: [
      { order: 1, instruction: 'Rinse the parboiled rice in several changes of water until the water runs clear. Soak in warm water for 20 minutes while you prepare the base. Drain well.', timerMinutes: 20 },
      { order: 2, instruction: 'Blend the Roma tomatoes, red bell peppers, habaneros, red onion, and tomato paste in a blender until very smooth. You should have about 5-6 cups of puree.', timerMinutes: null },
      { order: 3, instruction: 'Heat vegetable oil in a large, heavy-bottomed pot over medium-high heat. Fry the sliced yellow onion for 5 minutes until golden. Add garlic and ginger, cooking 1 minute more.', timerMinutes: 6 },
      { order: 4, instruction: 'Pour in the blended tomato-pepper mixture. Cook on medium-high heat, stirring occasionally, for 20-25 minutes until the sauce reduces by about half, darkens in color, and the oil floats to the top. This step is critical for deep flavor.', timerMinutes: 25 },
      { order: 5, instruction: 'Add curry powder, thyme, bay leaves, bouillon cube, salt, and broth. Stir well. Bring to a boil, then add the drained rice. Stir once to distribute evenly. The liquid should just cover the rice -- add a splash of water if needed.', timerMinutes: null },
      { order: 6, instruction: 'Cover the pot tightly with foil and then the lid (to trap all steam). Reduce heat to the lowest setting and cook for 30 minutes without opening the lid.', timerMinutes: 30 },
      { order: 7, instruction: 'After 30 minutes, remove the lid and foil. Fluff the rice gently with a fork, discarding bay leaves. The bottom layer should have a slightly toasted crust -- this is the prized "party jollof" bottom. Serve hot.', timerMinutes: null },
    ],
    notes: 'Nigerian jollof uses parboiled rice (not basmati) for the best texture. The key to great jollof is cooking the tomato base down long enough -- do not rush this step. For a smokier flavor, some cooks briefly place the uncovered pot over very high heat at the end to develop the bottom crust. Remove habanero seeds for a milder version or keep them for authentic heat.',

    communityRating: 4.7,
    communityRatingCount: 340,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-15').toISOString(),
  },

  // ─── SOUTH AFRICAN (1) ──────────────────────────────────────────────

  {
    title: 'Bobotie',
    description:
      'South Africa\'s national dish -- a Cape Malay-inspired spiced meat casserole topped with a savory egg custard that bakes to a golden set. Sweet, savory, and warmly spiced with curry, turmeric, and fruit chutney.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/bobotie.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/bobotie-prep.jpg', caption: 'Spiced meat filling in the baking dish', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 20,
    cookTime: 45,
    totalTime: 65,
    difficulty: 'medium',
    spiceLevel: 1,

    cuisine: 'South African',
    region: 'Africa',
    country: 'South Africa',

    categories: ['Dinner', 'Family Meals'],
    tags: ['high-protein', 'high-iron', 'nut-free', 'comfort-food', 'family-friendly', 'make-ahead', 'weeknight-dinner'],

    ageGroups: ['kid', 'teen', 'adult'],
    audience: 'family',

    nutrition: {
      calories: 440,
      protein: 30,
      carbs: 22,
      fat: 26,
      fiber: 2,
      sugar: 10,
      sodium: 620,
      iron: 4.5,
    },

    ingredients: [
      { qty: 2, unit: 'tbsp', item: 'vegetable oil', group: 'Meat Filling' },
      { qty: 1, unit: '', item: 'large yellow onion, finely diced', group: 'Meat Filling' },
      { qty: 3, unit: '', item: 'garlic cloves, minced', group: 'Meat Filling' },
      { qty: 2, unit: 'lb', item: 'ground beef or lamb', group: 'Meat Filling' },
      { qty: 2, unit: 'tbsp', item: 'curry powder', group: 'Meat Filling' },
      { qty: 1, unit: 'tsp', item: 'ground turmeric', group: 'Meat Filling' },
      { qty: 1, unit: 'tsp', item: 'ground cumin', group: 'Meat Filling' },
      { qty: 0.5, unit: 'tsp', item: 'ground cinnamon', group: 'Meat Filling' },
      { qty: 0.25, unit: 'tsp', item: 'ground cloves', group: 'Meat Filling' },
      { qty: 1.5, unit: 'tsp', item: 'salt', group: 'Meat Filling' },
      { qty: 0.5, unit: 'tsp', item: 'black pepper', group: 'Meat Filling' },
      { qty: 2, unit: 'slices', item: 'white bread, crusts removed, soaked in 0.5 cup milk', group: 'Meat Filling' },
      { qty: 2, unit: 'tbsp', item: 'fruit chutney (Mrs. Ball\'s or mango chutney)', group: 'Meat Filling' },
      { qty: 2, unit: 'tbsp', item: 'apricot jam', group: 'Meat Filling' },
      { qty: 1, unit: 'tbsp', item: 'Worcestershire sauce', group: 'Meat Filling' },
      { qty: 2, unit: 'tbsp', item: 'lemon juice', group: 'Meat Filling' },
      { qty: 0.25, unit: 'cup', item: 'raisins', group: 'Meat Filling' },
      { qty: 6, unit: '', item: 'bay leaves', group: 'Topping' },
      { qty: 2, unit: '', item: 'large eggs', group: 'Custard Topping' },
      { qty: 0.75, unit: 'cup', item: 'whole milk', group: 'Custard Topping' },
      { qty: 0.25, unit: 'tsp', item: 'ground turmeric', group: 'Custard Topping' },
      { qty: 0.25, unit: 'tsp', item: 'salt', group: 'Custard Topping' },
    ],
    steps: [
      { order: 1, instruction: 'Preheat the oven to 350 F. Grease a 9x13 inch baking dish. Heat oil in a large skillet over medium heat. Cook the onion for 5 minutes until soft, then add garlic and cook 1 more minute.', timerMinutes: 6 },
      { order: 2, instruction: 'Add the ground beef and break it up with a wooden spoon. Cook for 8 minutes until browned. Drain excess fat if needed. Add curry powder, turmeric, cumin, cinnamon, cloves, salt, and pepper. Stir for 2 minutes until fragrant.', timerMinutes: 10 },
      { order: 3, instruction: 'Squeeze the excess milk from the soaked bread (reserve the milk) and crumble the bread into the meat mixture. Add chutney, apricot jam, Worcestershire sauce, lemon juice, and raisins. Stir everything together and cook for 3 minutes.', timerMinutes: 3 },
      { order: 4, instruction: 'Transfer the meat mixture to the greased baking dish, pressing it down evenly. Tuck the bay leaves into the top of the meat.', timerMinutes: null },
      { order: 5, instruction: 'Whisk together eggs, milk (including the reserved bread-soaking milk), turmeric, and salt. Pour the custard evenly over the meat filling.', timerMinutes: null },
      { order: 6, instruction: 'Bake for 35-40 minutes until the custard is set and golden on top. Let rest for 10 minutes before serving.', timerMinutes: 40 },
      { order: 7, instruction: 'Serve warm with yellow rice (turmeric rice), sambals (diced banana, coconut, and chutney), and a green salad.', timerMinutes: null },
    ],
    notes: 'Bobotie (pronounced "ba-BOO-tee") is South Africa\'s answer to shepherd\'s pie, with Cape Malay influences from the spice trade. Mrs. Ball\'s Chutney is the traditional choice but any fruit chutney works. The bread soaked in milk is the traditional binder -- do not skip it. Leftovers reheat beautifully.',

    communityRating: 4.4,
    communityRatingCount: 155,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-02-15').toISOString(),
  },
];

export default middleEastAfricaRecipes;
